module.exports = __webpack_public_path__ + "img/1.e24b2874.png";